import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AgencyComponent } from './components/agency/agency.component';
import { BudgetComponent } from './components/budget/budget.component';
import { InterventionListComponent } from './components/intervention-list/intervention-list.component';
import { LoginComponent } from './components/login/login.component';
import { OrderComponent } from './components/order/order.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { StratListComponent } from './components/strat-list/strat-list.component';
import { StrategyDetailComponent } from './components/strategy-detail/strategy-detail.component';
import { StrategyComponent } from './components/strategy/strategy.component';
import { UserConfigurationComponent } from './components/user-configuration/user-configuration.component';
import { ErrorComponent } from './error.component';
import { ENavigationRoute } from './model/enum/navigation-route';
import { ConfigurationGuard } from './tools/configuration.guard';
import { LoginGuard } from './tools/login-guard';
import { RedirectComponent } from './components/redirect/redirect.component';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: ENavigationRoute.Home },
    { path: ENavigationRoute.Login, component: LoginComponent },
    { path: ENavigationRoute.ResetPassword, component: ResetPasswordComponent },
    { path: ENavigationRoute.Config, component: UserConfigurationComponent, canActivate: [ConfigurationGuard] },
    { path: ENavigationRoute.Agency, component: AgencyComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Home, component: StratListComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Strategy, component: StrategyComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.StrategyDetail, component: StrategyDetailComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Order, component: OrderComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.IntenventionList, component: InterventionListComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Budget, component: BudgetComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Error, component: ErrorComponent },
    { path: 'redirect', component: RedirectComponent },
    { path: '**', component: ErrorComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
